import declare from "dojo/_base/declare";
import _AggregateWithNewMixin from "csi/heading/_AggregateWithNewMixin";
import AggregateController from "csi/heading/AggregateController";

export = declare([AggregateController, _AggregateWithNewMixin], {
	aggregateNewNodeType: "Component",
});